export const CURRENCIES = {
    'COP': {
        locales: 'es-CO',
        symbol: '$'
    },
    'BRL': {
        locales: 'pt-BR',
        symbol: 'R$'
    }
};
//# sourceMappingURL=currency.js.map